export const mobileNavButton = {
    // color: 'white',
    background: '#ffffff',
    height: '42px',
    fontSize: '16px',
};
